export const followUpFormTranslations = {
    en: {
        // Page Title
        createNewFollowUp: "Create New Follow Up",

        // Form Labels
        followUpDate: "Follow Up Date",
        followUpTime: "Follow Up Time",
        callStatus: "Call Status",
        beneficiaryStatus: "Beneficiary Status",
        remark: "Remark",
        nextFollowUpDate: "Next Follow Up Date",
        nextFollowUpTime: "Next Follow Up Time",

        // Checkboxes
        closeFollowUp: "Close Follow Up?",
        nextFollowUp: "Next Follow Up?",

        // Placeholders
        selectPlaceholder: "Select...",
        remarkPlaceholder: "Remark...",

        // Validation Messages
        followUpDateRequired: "Please Select Follow Up Date",
        followUpTimeRequired: "Please Select Follow Up Time",
        callStatusRequired: "Please Select Status",
        remarkRequired: "Please Enter Remark",
        remarkMaxLength: "Remark must be at most 255 characters",
        nextFollowUpDateRequired: "Please Select Next Follow Up Date",
        nextFollowUpTimeRequired: "Please Select Next Follow Up Time",
        beneficiaryStatusRequired: "Please Select Beneficiary Status",

        // Button
        submit: "Submit",

        // Messages
        loading: "Loading...",
        successMessage: "Follow Up Created Successfully",
        errorMessage: "Unable to create follow up, please try again"
    },
    mr: {
        // Page Title
        createNewFollowUp: "नवीन फॉलो अप तयार करा",

        // Form Labels
        followUpDate: "फॉलो अप तारीख",
        followUpTime: "फॉलो अप वेळ",
        callStatus: "कॉल स्थिती",
        beneficiaryStatus: "लाभार्थी स्थिती",
        remark: "टिप्पणी",
        nextFollowUpDate: "पुढील फॉलो अप तारीख",
        nextFollowUpTime: "पुढील फॉलो अप वेळ",

        // Checkboxes
        closeFollowUp: "फॉलो अप बंद करायचे?",
        nextFollowUp: "पुढील फॉलो अप?",

        // Placeholders
        selectPlaceholder: "निवडा...",
        remarkPlaceholder: "टिप्पणी...",

        // Validation Messages
        followUpDateRequired: "कृपया फॉलो अप तारीख निवडा",
        followUpTimeRequired: "कृपया फॉलो अप वेळ निवडा",
        callStatusRequired: "कृपया स्थिती निवडा",
        remarkRequired: "कृपया टिप्पणी प्रविष्ट करा",
        remarkMaxLength: "टिप्पणी जास्तीत जास्त २५५ वर्णांची असावी",
        nextFollowUpDateRequired: "कृपया पुढील फॉलो अप तारीख निवडा",
        nextFollowUpTimeRequired: "कृपया पुढील फॉलो अप वेळ निवडा",
        beneficiaryStatusRequired: "कृपया लाभार्थी स्थिती निवडा",

        // Button
        submit: "सबमिट करा",

        // Messages
        loading: "लोड होत आहे...",
        successMessage: "फॉलो अप यशस्वीरित्या तयार केले",
        errorMessage: "फॉलो अप तयार करण्यात अयशस्वी, कृपया पुन्हा प्रयत्न करा"
    }
};
